/**
 * Single source of truth for API base URL.
 * Use this instead of hardcoding a domain so the app
 * works on any host (e.g. bizbridge510.com:3002 -> API same host :3001).
 */
export function getApiBaseUrl() {
  const envUrl = typeof process !== 'undefined' && process.env && process.env.REACT_APP_API_URL;
  if (envUrl && String(envUrl).trim()) {
    return String(envUrl).replace(/\/+$/, '');
  }
  if (typeof window !== 'undefined' && window.location) {
    const { hostname, port, protocol } = window.location;
    const apiPort = (
      (typeof process !== 'undefined' && process.env && process.env.REACT_APP_API_PORT) ||
      ''
    ).trim();

    // CRA dev server on 3002 — API is on 3001 (same host)
    if (port === '3002') {
      const apiProto = process.env.REACT_APP_API_PROTOCOL === 'http' ? 'http:' : 'https:';
      return `${apiProto}//${hostname}:3001`;
    }

    // SPA on https://domain (443) or http (80) but API on same hostname, different port (e.g. PM2 backend :3001)
    const onDefaultHttpPort = port === '' || port === '80' || port === '443';
    if (apiPort && onDefaultHttpPort) {
      const preferHttp = process.env.REACT_APP_API_PROTOCOL === 'http';
      const apiProto = preferHttp ? 'http:' : protocol === 'https:' ? 'https:' : 'http:';
      return `${apiProto}//${hostname}:${apiPort}`;
    }

    return window.location.origin;
  }
  return '';
}

export function getWsUrl() {
  const base = getApiBaseUrl();
  if (!base) return '';
  try {
    const u = new URL(base);
    u.protocol = u.protocol === 'https:' ? 'wss:' : 'ws:';
    return u.origin;
  } catch {
    return base.replace(/^https:/, 'wss:').replace(/^http:/, 'ws:');
  }
}

/** Safe parse fetch response to JSON; avoids "did not match the expected pattern" when server returns HTML or non-JSON. */
export async function safeParseJson(response) {
  const text = await response.text();
  if (!text || !text.trim()) return null;
  const ct = response.headers.get('content-type') || '';
  if (!ct.includes('application/json')) return null;
  try {
    return JSON.parse(text);
  } catch {
    return null;
  }
}
